import ApplicationLayout from 'components/layouts/ApplicationLayout'
import useWbsoQuestions from 'data/wbsoApp/useWbsoQuestions'
import ApplicationForm from './components/ApplicationForm'

const WBSOAppFormView = () => {
  const { data: questions, isLoading: loadingQuestions } = useWbsoQuestions()

  return (
    <ApplicationLayout>
      <ApplicationForm
        withIntro
        loading={loadingQuestions}
        questions={questions}
      />
    </ApplicationLayout>
  )
}

export default WBSOAppFormView
